import { Component } from '@angular/core';

@Component({
  selector: 'tun-thumb-down-icon-v5',
  templateUrl: './thumb-down-icon-v5.component.html',
  styleUrls: ['./thumb-down-icon-v5.component.scss']
})
export class ThumbDownIconV5Component {

}
